module.exports = __webpack_public_path__ + "img/749DCBE9905D384A.431d9323.png";